import React, { useState, useEffect } from 'react';
import { IOpenOrderData } from '../../../../store/ducks/long-steel-orders/types';
import { formatNumberTon } from '../../../../utils/formatNumbers';
import { KeyValueItem } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto/Title';
import { Container, SummaryContainer } from './styles';

interface IOrdersTotalValues {
  requested: number;
  pending: number;
  delivery: number;
  shipment: number;
  billed: number;
}

interface IOrdersSummaryProps {
  filteredOrders: IOpenOrderData[];
  loading: boolean;
}

const OrdersSummary: React.FC<IOrdersSummaryProps> = ({
  filteredOrders,
  loading
}) => {
  const [orders, setOrders] = useState(filteredOrders);
  const [totals, setTotals] = useState<IOrdersTotalValues>();

  const updateValues = () => {
    const newTotals = filteredOrders.reduce(
      (prev: IOrdersTotalValues, curr) => {
        return {
          requested:
            prev.requested +
            Number(curr.quantities.requestedConversionQuantity),
          pending:
            prev.pending + Number(curr.quantities.pendingConversionQuantity),
          delivery:
            prev.delivery + Number(curr.quantities.deliveryConversionQuantity),
          shipment:
            prev.shipment + Number(curr.quantities.shipmentConversionQuantity),
          billed: prev.billed + Number(curr.quantities.billedConversionQuantity)
        };
      },
      { requested: 0, pending: 0, delivery: 0, shipment: 0, billed: 0 }
    );

    setOrders(filteredOrders);
    setTotals(newTotals);
  };

  useEffect(() => {
    if (filteredOrders !== orders || !totals) {
      updateValues();
    }
  });

  return (
    <>
      {!loading && (
        <Container>
          <Title level={3}>Resumo dos pedidos</Title>
          <SummaryContainer>
            <KeyValueItem title="Total solicitado">{`${
              totals && totals.requested
                ? formatNumberTon(totals.requested.toString())
                : 0
            } t`}</KeyValueItem>
            {totals && totals.billed > 0 && (
              <KeyValueItem title="Faturado">{`${formatNumberTon(
                totals.billed.toString()
              )} t`}</KeyValueItem>
            )}
            {totals && totals.delivery > 0 && (
              <KeyValueItem title="Em remessa">{`${formatNumberTon(
                totals.delivery.toString()
              )} t`}</KeyValueItem>
            )}

            {totals && totals.shipment > 0 && (
              <KeyValueItem title="Em carregamento">{`${formatNumberTon(
                totals.shipment.toString()
              )} t`}</KeyValueItem>
            )}

            {totals && totals.pending > 0 && (
              <KeyValueItem title="Saldo">{`${formatNumberTon(
                totals.pending.toString()
              )} t`}</KeyValueItem>
            )}
          </SummaryContainer>
        </Container>
      )}
    </>
  );
};

export default OrdersSummary;
